/* tslint:disable */
/* eslint-disable */
/**
 * BS2
 * BoostSales 2
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PartnerAddressProjection
 */
export interface PartnerAddressProjection {
    /**
     * 
     * @type {string}
     * @memberof PartnerAddressProjection
     */
    street?: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerAddressProjection
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerAddressProjection
     */
    zip?: string;
}

/**
 * Check if a given object implements the PartnerAddressProjection interface.
 */
export function instanceOfPartnerAddressProjection(value: object): value is PartnerAddressProjection {
    return true;
}

export function PartnerAddressProjectionFromJSON(json: any): PartnerAddressProjection {
    return PartnerAddressProjectionFromJSONTyped(json, false);
}

export function PartnerAddressProjectionFromJSONTyped(json: any, ignoreDiscriminator: boolean): PartnerAddressProjection {
    if (json == null) {
        return json;
    }
    return {
        
        'street': json['street'] == null ? undefined : json['street'],
        'city': json['city'] == null ? undefined : json['city'],
        'zip': json['zip'] == null ? undefined : json['zip'],
    };
}

export function PartnerAddressProjectionToJSON(json: any): PartnerAddressProjection {
    return PartnerAddressProjectionToJSONTyped(json, false);
}

export function PartnerAddressProjectionToJSONTyped(value?: PartnerAddressProjection | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'street': value['street'],
        'city': value['city'],
        'zip': value['zip'],
    };
}

